import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthPage } from '@/components/AuthPage';
import ResetPassword from '@/components/resetpassword';

interface PublicRoutesProps {
  onAuthSuccess: (token?: string) => void;
}

export function PublicRoutes({ onAuthSuccess }: PublicRoutesProps) {
  return (
    <Routes>
      <Route path="/login" element={<AuthPage mode="login" onSuccess={onAuthSuccess} />} />
      <Route path="/signup" element={<AuthPage mode="signup" onSuccess={onAuthSuccess} />} />
      <Route path="/reset-password" element={<ResetPassword onSuccess={onAuthSuccess} />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
